import React, { useState } from "react";

import Header from "../layout/Header";
import "./index.scss";
import image from "../../assets/payement.png";
import PaypalButton from "../paypalButton";

const SlideSoutien = () => {
  const [userData, setUserData] = useState({
    email: "",
    organisation: false,
    civilite: "",
    nom: "",
    prenom: "",
    telephone: "",
    pays: "",
  });
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setUserData({
      ...userData,
      [name]: type === "checkbox" ? checked : value,
    });
  };
  const [amount, setAmount] = useState(null);
  const [amountValue, setAmountValue] = useState(null); // État pour le montant sélectionné
  const [isCustomAmount, setIsCustomAmount] = useState(false);

  const handleAmountClick = (value) => {
    setIsCustomAmount(false); // Désactiver le champ d'entrée si un bouton prédéfini est cliqué
    setAmount(value); // Mettre à jour le montant
  };

  const handleCustomAmountClick = () => {
    setIsCustomAmount(true); // Activer le champ d'entrée
    setAmount(null); // Réinitialiser le montant
  };
  const handleCustomAmountAppouve = () => {
    setAmount(amountValue); // Réinitialiser le montant
  };
  const handleCustomAmountChange = (e) => {
    setAmountValue(e.target.value); // Mettre à jour le montant avec la valeur saisie
  };
  // Fonction pour vérifier si tous les champs sont remplis
  const isFormComplete = () => {
    // Vérifie si tous les champs requis dans userData sont remplis
    const allFieldsFilled = Object.values(userData).every(
      (value) => value !== "" && value !== null
    );
    // Vérifie si le montant est défini
    return allFieldsFilled && amount !== null && amount > 0;
  };

  return (
    <div className="slide-soutien">
      <Header />
      <div className="slide-soutien-container ">
        <div className="row w-100 ">
          <div className="col-lg-4 mb-4 ">
            <div className=" slide-soutien-card">
              <div className="card">
                <div className="title-soutien">
                  <h3 className="text-title-soutient">Le montant de mon don</h3>
                </div>

                <div className="image-container w-100 ">
                  <img
                    src={image} // Remplacez par votre image
                    alt="Donation"
                    className="img-fluid "
                  />
                </div>
                <div className="donation-amounts w-100">
                  <button
                    className={`btn ${amount === 50 ? "active" : ""}`}
                    onClick={() => handleAmountClick(50)}
                  >
                    50€
                  </button>
                  <button
                    className={`btn ${amount === 90 ? "active" : ""}`}
                    onClick={() => handleAmountClick(90)}
                  >
                    90€
                  </button>
                  <button
                    className={`btn ${amount === 150 ? "active" : ""}`}
                    onClick={() => handleAmountClick(150)}
                  >
                    150€
                  </button>
                  <button
                    className={`btn ${amount === 200 ? "active" : ""}`}
                    onClick={() => handleAmountClick(200)}
                  >
                    200€
                  </button>
                </div>
                {isCustomAmount && (
                  <div className="donation-amounts w-100">
                    <input
                      type="number"
                      className="form-control mt-3"
                      placeholder="Autre montant"
                      onChange={handleCustomAmountChange}
                    />
                    <button
                      className={`btn ${amount === amountValue ? "active" : ""}`}
                      onClick={handleCustomAmountAppouve}
                    >
                      Approuer
                    </button>
                  </div>
                )}
                <button
                  className="btn btn-amounts w-100 "
                  onClick={handleCustomAmountClick}
                >
                  Autre montant
                </button>
              </div>
            </div>
          </div>
          <div className="col-lg-4  mb-4 ">
            <div className=" slide-soutien-card">
              <div className="card">
                {" "}
                <div className="title-soutien">
                  <h3 className="text-title-soutient">Mes cordonnées</h3>
                </div>
                <div className="form-container">
                  <form className="custom-form">
                    <div className="form-group mt-4">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        onChange={handleInputChange}
                        placeholder=" " // Laisser un espace pour activer la gestion du placeholder-shown
                      />
                      <label htmlFor="email" className="form-label">
                        <i className="bi bi-envelope"></i> Email
                      </label>
                    </div>

                    <div className=" d-flex  align-items-center mb-3">
                      <input
                        type="checkbox"
                        id="organization"
                        name="organisation"
                        onChange={handleInputChange}
                        className="form-check-input"
                      />
                      <label
                        htmlFor="organization"
                        className="form-check-label"
                      >
                        Je suis une organisation ou une société
                      </label>
                    </div>

                    <div className="form-group">
                      <select
                        id="civility"
                        onChange={handleInputChange}
                        className="form-select"
                        defaultValue=""
                        name="civilite"
                      >
                        <option value="" disabled>
                          Civilité
                        </option>
                        <option value="Mr">Mr</option>
                        <option value="Mme">Mme</option>
                        <option value="Mlle">Mlle</option>
                      </select>
                    </div>

                    <div className="form-row">
                      <div className="form-group col">
                        <input
                          type="text"
                          name="nom"
                          id="lastName"
                          onChange={handleInputChange}
                          className="form-control"
                          placeholder=""
                        />
                        <label htmlFor="lastName" className="form-label">
                          Nom*
                        </label>
                      </div>
                      <div className="form-group col">
                        <input
                          type="text"
                          id="firstName"
                          name="prenom"
                          onChange={handleInputChange}
                          className="form-control"
                          placeholder=""
                        />
                        <label htmlFor="firstName" className="form-label">
                          Prénom*
                        </label>
                      </div>
                    </div>

                    <div className="form-group">
                      <input
                        type="tel"
                        id="phone"
                        name="telephone"
                        onChange={handleInputChange}
                        className="form-control"
                        placeholder=""
                      />
                      <label htmlFor="phone" className="form-label">
                        Téléphone*
                      </label>
                    </div>

                    <div className="form-group">
                      <select
                        name="pays"
                        id="country"
                        className="form-select"
                        onChange={handleInputChange}
                        defaultValue=""
                      >
                        <option value="" disabled>
                          Pays*
                        </option>
                        <option value="France">France</option>
                        <option value="Belgique">Belgique</option>
                        <option value="Suisse">Suisse</option>
                        <option value="Autre">Autre</option>
                      </select>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 mb-4 ">
            <div className=" slide-soutien-card">
              <div className="card">
                {" "}
                <div className="title-soutien">
                  <h3 className="text-title-soutient">Mode de paiement</h3>
                </div>
                {/*<div className="paypal-option w-100">
                  <label className="paypal-label w-100">
                    <input
                      type="radio"
                      name="payment"
                      className="paypal-radio"
                    />
                    <span className="paypal-text">PayPal</span>
                    <img
                      src="https://www.paypalobjects.com/webstatic/icon/pp258.png"
                      alt="PayPal Logo"
                      className="paypal-logo"
                    />
                  </label>
                </div>*/}
                <div className="mt-4 paypal-button">
                  <PaypalButton
                    total={amount}
                    userData={userData}
                    disabled={!isFormComplete()} // Désactive le bouton si le formulaire est incomplet
                  />
                </div>
                {/*
                <button className="btn btn-primary mt-4 p-2 w-100">
                  Valider
                </button>{" "}
                */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SlideSoutien;
